import { Link } from 'react-router-dom';

import {
  ADDRESS_LINES,
  PHONE,
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from './footerLinks';

/** The slim footer for public standalone pages (credential verification). */
export const CompactFooter = () => (
  <footer className="bg-heading px-4 py-6 text-sm text-primary-foreground sm:px-10 lg:px-24">
    <div className="mx-auto flex max-w-screen-2xl flex-col gap-4">
      <div className="flex flex-col gap-3">
        <p>{ADDRESS_LINES.join(' ')}</p>
        <Link to={PHONE.href} className="text-brand-yellow">
          {PHONE.label}
        </Link>
      </div>
      <div className="flex flex-col justify-between gap-2 border-t border-primary-foreground/30 pt-4 text-xs md:flex-row">
        <p>
          Accredited by the Distance Education Accrediting Commission (DEAC)
        </p>
        <p>
          Copyright © {new Date().getFullYear()} Frontier Institute of
          Technology &nbsp;|&nbsp;
          <Link
            to={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-yellow"
          >
            Privacy Policy
          </Link>
          &nbsp;|&nbsp;
          <Link
            to={TERMS_OF_USE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-yellow"
          >
            Terms of Use
          </Link>
        </p>
      </div>
    </div>
  </footer>
);
